var isDate = require("lodash.isdate");
var timeago = require("simple-timeago");

module.exports = function(since, until){
  if((since && !isDate(since)) || (until && !isDate(until))){
    return "???";
  }
  return timeago(since || null, until || null);
};



//////////////////
// WEBPACK FOOTER
// ./~/simple-timeago.handle-bad-input/index.js
// module id = 170
// module chunks = 0 1 2 3 4